export function isMediumViewport(): boolean {
	const innerWidth = window.innerWidth
	const isMediumViewport = innerWidth >= 800 && innerWidth <= 1199
	return isMediumViewport
}

export const isLargeViewport = (): boolean => window.innerWidth > 1199

export const isSmallViewport = (): boolean => window.innerWidth <= 799
